import { JhButton } from "designPackages/buttonPackage";
import { JhText } from "designPackages/textPackage";

const ActionButton = ({ iconSrc, iconAlt, label, onClick }) => {
  return (
    <JhButton variant="outline" className="flex-1 py-3" onClick={onClick}>
      <JhText variant="subtitle-3" color="foreground" className="flex">
        <img
          src={iconSrc}
          alt={iconAlt}
          width={16}
          height={16}
          className="mr-1"
        />
        {label}
      </JhText>
    </JhButton>
  );
};

export default ActionButton;
